export default __webpack_public_path__ + "static/media/DoneBottom.ed16c119.svg";